import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import moment from 'moment';
import React, { Fragment, FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { SegmentResponse } from '../models/itinerary';
import { AppState } from '../store/model';
import { getSegmentsGroupedByDay, isSaviSelectIntl } from '../store/reducers/itinerary/selectors';
import { spacings } from './lab/spacings';
import { Subheading } from './lab/TextGroup/Subheading';
import { Segments } from './Segments';
import { getLandSegmentsGroupedByDayForSaviSelectIntl } from '../store/reducers/itinerary/saviSelectIntlSelector';

interface StateProps {
  segmentIds: Record<string, Array<SegmentResponse['orderId']>>;
}

interface SegmentGroupsProps
  extends StateProps,
    WithStyles<typeof styles>,
    InjectedIntlProps {}

const SegmentGroupsBase: FunctionComponent<SegmentGroupsProps> = ({
  classes,
  segmentIds = {},
}) => {
  const segments = Object.entries(segmentIds);

  return (
    <>
      {segments.map(([key, ids], index) => (
        <Fragment key={index}>
          <Subheading>{moment(key).format('ddd D MMM')}</Subheading>
          <div className={classes.segments}>
            <Segments ids={ids} />
          </div>
        </Fragment>
      ))}
    </>
  );
};

const mapStateToProps = (state: AppState): StateProps => ({
  segmentIds: !isSaviSelectIntl(state) ? getSegmentsGroupedByDay(state) : getLandSegmentsGroupedByDayForSaviSelectIntl(state)
});

// styled
const styles = (theme: Theme) => {
  const {
    between: {
      card: { header: cardHeaderSpacing },
    },
  } = spacings(theme);

  return createStyles({
    segments: {
      ...cardHeaderSpacing,
    },
  });
};

const enhance = compose<SegmentGroupsProps, {}>(
  connect(mapStateToProps),
  withStyles(styles),
  injectIntl,
);

/**
 * Group of segments (grouped by date)
 */
export const SegmentGroups = enhance(SegmentGroupsBase);

SegmentGroups.displayName = 'SegmentGroups';
